/**
* @file 框架-顶部-左侧Logo和公司名称
* */
<template>
  <div class="header-left flex">
    <img 
      @click="goHome" 
      v-if="organization.logo" 
      class="logo" 
      :src="mixinQiniuImg(organization.logo)" 
    />
    <p @click="goHome" class="company-name">{{ organization.name }}</p>
  </div>
</template>

<script>
export default {
  name: 'HeaderLeft',
  props: {
    organization: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultActive: sessionStorage.getItem("menuActiveUrl")
    }
  },
  methods: {
    goHome() {
      if (this.defaultActive) {
        this.$router.push(this.defaultActive)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header-left {
  flex: 1;
  cursor: pointer;

  .logo {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    margin-right: 14px;
    background-color: #ebebeb;
    box-shadow: 
      0 2px 8px rgba(43, 119, 255, 0.3),
      0 0 15px rgba(43, 119, 255, 0.2),
      0 0 25px rgba(43, 119, 255, 0.1);
    transition: all 0.3s ease;
    animation: logoGlow 2s ease-in-out infinite alternate;
    
    &:hover {
      transform: scale(1.1);
      box-shadow: 
        0 4px 12px rgba(43, 119, 255, 0.4),
        0 0 20px rgba(43, 119, 255, 0.3),
        0 0 35px rgba(43, 119, 255, 0.2);
    }
  }

  .company-name {
    font-size: 20px;
    margin-right: 80px;
    font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 2px;
    color: #fff;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  }
}

@keyframes logoGlow {
  0% {
    box-shadow: 
      0 2px 8px rgba(43, 119, 255, 0.3),
      0 0 15px rgba(43, 119, 255, 0.2),
      0 0 25px rgba(43, 119, 255, 0.1);
  }
  100% {
    box-shadow: 
      0 2px 12px rgba(43, 119, 255, 0.5),
      0 0 20px rgba(43, 119, 255, 0.35),
      0 0 35px rgba(43, 119, 255, 0.2);
  }
}
</style>
